import { Card } from "react-bootstrap";
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from "recharts";
import { formatVND as fmtVND, formatMoney } from "../utils/moneyFormat";

const cardStyle = { boxShadow: "0 2px 8px rgba(0,0,0,0.1)" };

const fmtShortMoney = (v) => {
  const n = Number(v || 0);
  const abs = Math.abs(n);
  if (abs >= 1e9) return `${(n / 1e9).toFixed(1)} tỷ`;
  if (abs >= 1e6) return `${(n / 1e6).toFixed(1)} tr`;
  return formatMoney(n);
};

const fmtShortNumber = (v) => formatMoney(Math.round(Number(v || 0)));

const ChartTooltip = ({ active, payload, label, valueFormat = "money" }) => {
  if (!active || !payload?.length) return null;
  const fmtVal = valueFormat === "number"
    ? (v) => formatMoney(v)
    : (v) => fmtVND(v);
  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e9ecef",
        borderRadius: 8,
        padding: "10px 14px",
        boxShadow: "0 4px 12px rgba(0,0,0,.1)",
        fontSize: "0.75rem",
      }}
    >
      <div className="fw-bold mb-1">{label}</div>
      {payload.map((p) => (
        <div key={p.dataKey} style={{ color: p.color }}>
          {p.name}: {fmtVal(p.value)}
        </div>
      ))}
    </div>
  );
};

/**
 * @param {Array<{bucket:string,current:number,previous:number}>} data
 * @param {string} currentLabel
 * @param {string} previousLabel
 * @param {string} title
 * @param {"money"|"number"} valueFormat
 */
const PeriodCompareLineChart = ({
  data = [],
  title = "So sánh kỳ này / kỳ trước",
  currentLabel = "Kỳ này",
  previousLabel = "Kỳ trước",
  currentColor = "#198754",
  previousColor = "#6c757d",
  valueFormat = "money",
}) => {
  if (!data?.length) return null;

  const chartData = data.map((d) => ({
    bucket: d.bucket,
    [currentLabel]: Number(d.current || 0),
    [previousLabel]: Number(d.previous || 0),
  }));

  const yTickFormatter = valueFormat === "number" ? fmtShortNumber : fmtShortMoney;

  return (
    <Card className="mb-3" style={cardStyle}>
      <Card.Body>
        <h6 className="fw-semibold mb-3">{title}</h6>
        <div className="acc-chart-wrap">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={chartData} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="bucket" tick={{ fontSize: 12 }} />
              <YAxis tickFormatter={yTickFormatter} tick={{ fontSize: 12 }} width={70} />
              <Tooltip content={<ChartTooltip valueFormat={valueFormat} />} />
              <Legend />
              <Line
                type="monotone"
                dataKey={currentLabel}
                stroke={currentColor}
                strokeWidth={2.5}
                dot={{ r: 3 }}
                activeDot={{ r: 5 }}
              />
              <Line
                type="monotone"
                dataKey={previousLabel}
                stroke={previousColor}
                strokeWidth={2}
                strokeDasharray="6 4"
                dot={{ r: 2 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </Card.Body>
    </Card>
  );
};

export default PeriodCompareLineChart;
